import React from 'react'
import "./Navbar.css";
import { useEffect, useState } from 'react';
import  Button  from "../button/Button"
import  Dropdown  from "../dropdown/Dropdown"
import { Link } from "react-router-dom"
import logo from "../../brainacs-Logo.svg"
import contactUsIcon from "../navbar/ContactUsIconNavbar.svg"

import { useLocation } from 'react-router-dom';


const Navbar = () => {
    const dropdown = true;
    const [click, setClick] = useState(false);
    const [drop, setDrop] = useState(false);
    const handleDrop = () => {
        setDrop(!drop);
    }

    const handleclick = () => {
        setClick(!click);
        if (!click) {
            document.body.style.overflow = "hidden"; // Scrolling deaktivieren
        } else {
            document.body.style.overflow = "auto"; // Scrolling wieder aktivieren
        }
    }

    const closeMobileMenu = () => {
        setClick(false);
        document.body.style.overflow = "auto"; // Scrolling wieder aktivieren
    }

    const location = useLocation().pathname;

    const [width, setWidth] = useState(window.innerWidth);
    function handleWindowSizeChange() {
      setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
        window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    const isMobile = width <= 600;
    const iconMobile =  isMobile ? 
        <> <i className="fa-solid fa-chevron-right fa-2xs custom-icon-menu"></i> {/* Pfeil nach rechts */} </> : ''
  return (
    <>
        <nav className='navbar-container' >
            <div className='logo-box'>
                <Link to="/" className='navbar-logo'>
                    <img className='logo-width' src={logo} alt='Logo'/>
                </Link>
                <h1 className='logo-text'>Brainacs</h1> 
                <h1 className='logo-punkt'>.</h1>
            </div>
            <div className='menu-icon' onClick={handleclick}>
                <i className={click ? 'fas fa-times' : 'fas fa-bars' } />
            </div>
                <ul className={click ? 'nav-menu active' : 'nav-menu' } >
                    <div className={isMobile ? 'active-menu-items-mobile' : 'nav-menu'}>
                    <li className='nav-item' >
                        <Link to='/' className='nav-links' onClick={closeMobileMenu} >
                            Home
                        </Link>
                        { iconMobile }
                    </li>
                    <li className='nav-item'>
                        <Link to='/ueber-uns' className='nav-links' onClick={closeMobileMenu}>
                            Über uns
                        </Link>
                        { iconMobile }
                    </li>
                    { 
                    !dropdown &&
                    <li className='nav-item' onClick={handleDrop}>
                        <Link to={location} className='nav-links'>
                        <i className={drop ? "fa-solid fa-chevron-up fa-2xs": "fa-solid fa-chevron-down fa-2xs"}></i> Themengebiete 
                        </Link>
                        {drop && <Dropdown />}
                    </li>
                    }
                    <li className='nav-item'>
                        <Link to='/themengebiete' className='nav-links' onClick={closeMobileMenu}>
                            Themengebiete
                        </Link>
                        { iconMobile }
                    </li>
                    <li className='nav-item'>
                        <Link to='/leistungen' className='nav-links' onClick={closeMobileMenu}>
                            Leistungen
                        </Link>
                        { iconMobile }
                    </li>
                    <div className='menu-contact-us-btn-mobile-position'>
                        <Link to="/kontaktiere-uns">
                            <button onClick={closeMobileMenu} className="menu-contact-us-btn-mobile">
                                Kontaktiere uns
                            </button>
                        </Link> 
                    </div>                   
                    </div>
                </ul>
            <div className='button-margin'>
            {
                <Button />
            }
            {
                <div className='icon-headset'>
                    <Link to="/kontaktiere-uns">
                        <img className='contact-us-icon' src={contactUsIcon} alt=''/>
                    </Link>
                </div>
            }
            </div>
        </nav>
    </>
  )
}

export default Navbar